export const palette = {
  dark: '#262626',
  gray: '#444444',
  light: '#dfdfdf',
  blue: '#61c9f2',
  blues: [
    '#475459',
    '#70848c',
    '#73aabf',
    '#499dbd',
  ],
  gradient: {
    dark: '#8888, #222a, #000c',
  },
}
